import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination, Parallax, Controller } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Pagination, Parallax ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'slide',
            watchSlidesProgress: true,
            parallax: true,

            // Pagination (bullet)
            pagination: {
                el: '.c-pagination__bullets',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.slideshow .swiper-container', config);

            if (dataSlideAuto === "1") {
                let boutonPlayPause = document.getElementById("js-boutonAutoplay");
                let iconPause = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--pause");
                let iconPlay = boutonPlayPause.querySelector(".nav-swiper-autoplay__icon--play");

            // Initial state adjustment
                if (swiperHome.autoplay.running) {
                    iconPause.classList.remove("hidden");
                    iconPlay.classList.add("hidden");
                } else {
                    iconPause.classList.add("hidden");
                    iconPlay.classList.remove("hidden");
                }

            boutonPlayPause.addEventListener("click", function () {
                if (swiperHome.autoplay.running) {
                swiperHome.autoplay.stop();

                boutonPlayPause.classList.remove("nav-swiper-autoplay--play");
                boutonPlayPause.classList.add("nav-swiper-autoplay--pause");
                iconPause.classList.add("hidden");
                iconPlay.classList.remove("hidden");
                } else {
                swiperHome.autoplay.start();

                boutonPlayPause.classList.remove("nav-swiper-autoplay--pause");
                boutonPlayPause.classList.add("nav-swiper-autoplay--play");
                iconPause.classList.remove("hidden");
                iconPlay.classList.add("hidden");
                }
            });
            }
        }
    }

    // Slider news
    const newsTopSlider = document.querySelector(".js-news-top-slider");
    const newsCategorySlider = document.querySelector(".js-news-category-slider");

    if (newsTopSlider || newsCategorySlider) {
        Swiper.use([Navigation, A11y]);
    }

    if (newsTopSlider) {
        const postsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,

            breakpoints: {
                1201: {
                    allowTouchMove: false,
                    spaceBetween: 30,
                    slidesPerView: 2.4,
                },

                961: {
                    allowTouchMove: false,
                    spaceBetween: 20,
                    slidesPerView: 2.29,
                },

                641: {
                    allowTouchMove: true,
                    spaceBetween: 20,
                    slidesPerView: 2,
                },

                0: {
                    allowTouchMove: true,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
            },

            navigation: {
                nextEl: `.news__navigation__button--next`,
                prevEl: `.news__navigation__button--prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: "Diapositive précédente",
                nextSlideMessage: "Diapositive suivante",
                slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };

        new Swiper(".js-news-top-slider", postsConfig);
    }

    if (newsCategorySlider) {
        const categoryConfig = {
            effect: "fade",
            grabCursor: "false",
            speed: 500,
            loop: false,
            fadeEffect: {
                crossFade: true,
            },
    
            breakpoints: {
                1201: {
                    allowTouchMove: false,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
    
                961: {
                    allowTouchMove: false,
                    spaceBetween: 20,
                    slidesPerView: 1,
                },
    
                641: {
                    allowTouchMove: true,
                    spaceBetween: 16,
                    slidesPerView: 1,
                },
    
                0: {
                    allowTouchMove: true,
                    spaceBetween: 12,
                    slidesPerView: 1,
                },
            },
    
            navigation: {
                nextEl: `.news__category__navigation-button--next`,
                prevEl: `.news__category__navigation-button--prev`,
            },
    
            a11y: {
                enabled: true,
                prevSlideMessage: "Diapositive précédente",
                nextSlideMessage: "Diapositive suivante",
                slideLabelMessage: "{{index}} / {{slidesLength}}",
            },
    
            on: {
                init: function () {
                    updateParentLink(this);
                },
                slideChange: function () {
                    updateParentLink(this);
                },
            },
        };
    
        function updateParentLink(swiperInstance) {
            const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
            const parentLink = swiperInstance.el.closest('.news__category');
    
            if (parentLink && activeSlide?.dataset.href) {
                parentLink.href = activeSlide.dataset.href;
            }
        }
    
        new Swiper(".js-news-category-slider", categoryConfig);
    }

     // Slider events
     const eventsSlider = document.querySelector(".events .swiper-container") !== null;
     if (eventsSlider) {
        let eventsSlides = document.querySelectorAll(".events .swiper-container .swiper-slide").length;
 
        Swiper.use([Navigation, A11y]);
 
        let eventsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,
            slidesPerView: 3,
    
            breakpoints: {
            1201: {
                allowTouchMove: false,
                spaceBetween: 30,
                slidesPerView: 3,
            },
    
            961: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 3,
            },
    
            641: {
                allowTouchMove: false,
                spaceBetween: 20,
                slidesPerView: 2,
            },
    
            0: {
                allowTouchMove: true,
                spaceBetween: 20,
                slidesPerView: 1,
            },
            },
    
            navigation: {
            nextEl: `.events__navigation__button--next`,
            prevEl: `.events__navigation__button--prev`,
            },
    
            a11y: {
            enabled: true,
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
            slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };
 
        const eventsNav = document.querySelector(".events__navigation");
 
        let swiperEvents = new Swiper(".events .swiper-container", eventsConfig);
    }

    // === Slider Projects : IMAGE ===
    const projectsImageSliderEl = document.querySelector(".js-projects-slider-image");
    const projectsContentSliderEl = document.querySelector(".js-projects-slider-content");

    if (projectsImageSliderEl && projectsContentSliderEl) {
        Swiper.use([Navigation, EffectFade, A11y, Controller]);

        const swiperProjectsImage = new Swiper(projectsImageSliderEl, {
            effect: "slide",
            speed: 700,
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20,
            grabCursor: true,
            breakpoints: {
                771: {
                    allowTouchMove: false,
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                0: {
                    allowTouchMove: true,
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
            },
            navigation: {
                nextEl: ".projects__navigation__button--next",
                prevEl: ".projects__navigation__button--prev",
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Diapositive précédente",
                nextSlideMessage: "Diapositive suivante",
                slideLabelMessage: "{{index}} / {{slidesLength}}",
            },
        });

        const swiperProjectsContent = new Swiper(projectsContentSliderEl, {
            effect: "fade",
            speed: 700,
            loop: false,
            slidesPerView: 1,
            allowTouchMove: true,
            fadeEffect: {
                crossFade: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Diapositive précédente",
                nextSlideMessage: "Diapositive suivante",
                slideLabelMessage: "{{index}} / {{slidesLength}}",
            },
            navigation: {
                nextEl: ".projects__navigation__button--next",
                prevEl: ".projects__navigation__button--prev",
            },
        });

        // Synchronisation bidirectionnelle
        swiperProjectsImage.controller.control = swiperProjectsContent;
        swiperProjectsContent.controller.control = swiperProjectsImage;
    }



    // slidder pictures
    const picturesSlider = document.querySelector(".pictures .swiper-container") !== null;
    if (picturesSlider && window.innerWidth < 961) {
        let picturesSlides = document.querySelectorAll(".pictures .swiper-container .swiper-slide").length;

        Swiper.use([Navigation, A11y]);

        let eventsConfig = {
            effect: "slide",
            grabCursor: "true",
            speed: 700,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 20,

            breakpoints: {
                    641: {
                        allowTouchMove: false,
                        spaceBetween: 20,
                        slidesPerView: 2,
                    },
                    0: {
                        allowTouchMove: true,
                        spaceBetween: 10,
                        slidesPerView: 1,
                    },
                },
            navigation: {
            nextEl: `.pictures__navigation__button--next`,
            prevEl: `.pictures__navigation__button--prev`,
            },

            a11y: {
            enabled: true,
            prevSlideMessage: "Diapositive précédente",
            nextSlideMessage: "Diapositive suivante",
            slideLabelMessage: "{{index}} / {{slidesLength}}", // default
            },
        };

        const eventsNav = document.querySelector(".pictures__navigation");

        let swiperEvents = new Swiper(".pictures .swiper-container", eventsConfig);
    }
}
